import Point from '../geom/Point.js';

var MathUtils = {

    toRadians: function(degrees) {
        return (degrees * (Math.PI / 180));
    },

    toDegrees: function(radian) {
        return (radian * (180 / Math.PI));
    },

    bound: function(val, valMin, valMax) {
        var res = Math.max(val, valMin);
        res = Math.min(val, valMax);
        return res;
    },

    average: function(values) {
        var result = 0;
        if (values) {
            for (var i = 0; i < values.length; i++) {
                result += values[i];
            }
            result = result / values.length;
        }
        return result;
    },

    cartesianToBarycentric: function(t1, t2, t3, point) {
        var detT = (t2.y - t3.y) * (t1.x - t3.x) + (t3.x - t2.x) * (t1.y - t3.y);

        var u = ((t2.y - t3.y) * (point.x - t3.x) + (t3.x - t2.x) * (point.y - t3.y)) / detT;
        var v = ((t3.y - t1.y) * (point.x - t3.x) + (t1.x - t3.x) * (point.y - t3.y)) / detT;
        var w = 1 - u - v;
        return [u, v, w];
    },

    barycentricToCartesian: function(barycentricCoordinate, t1, t2, t3) {
        var u = barycentricCoordinate[0];
        var v = barycentricCoordinate[1];
        var w = barycentricCoordinate[2];

        var x = (u * t1.x) + (v * t2.x) + (w * t3.x);
        var y = (u * t1.y) + (v * t2.y) + (w * t3.y);

        return new Point(x, y);
    },

    roundToDecimal: function(value, decimals) {
        var d = Math.round(Math.pow(10, decimals));
        var v = Math.round(value * d);
        var result = v / d;
        return result;
    },

    contains: function(value, min, max) {
        return (value >= min && value <= max) || (value <= min && value >= max);
    }
};

export default MathUtils;